<template>
  <!-- 企业文化 -->
  <div class="culture">
    <el-table class="eltabletl" border :data="tableData" style="width: 100%">
      <el-table-column prop="num" label="编号" width="400"></el-table-column>
      <el-table-column prop="orderNum" label="排序" width="200"></el-table-column>
      <el-table-column prop="title" label="标题"></el-table-column>
      <el-table-column prop="createTime" label="发布时间" width="400"></el-table-column>

      <el-table-column fixed="right" label="操作" width="300">
        <template slot="header">
            操作
            <i @click="addFrom()" style="font-size: 0.9rem;font-weight: 600;cursor:pointer;position: relative;color: #00ffff;" class="el-icon-circle-plus-outline"></i>
         
        </template>

        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click.stop="edit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click.stop="del(scope.row)">删除</el-button>
          <!-- <el-button type="text" size="small">编辑</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!--详情-->
    <el-dialog v-dialogDrag title="企业文化详情" :visible.sync="addformData" width="50%" :before-close="handleClose">
      <div style="min-height: 450px">
        <el-form ref="formData" :model="formData" label-width="6rem">
          <el-col :span="6">
            <el-form-item label="名称">
              <el-input required maxlength="200" v-model="formData.title" placeholder="请输入名称" :disabled="flag == 'look'"></el-input>
            </el-form-item>
            <el-form-item label="排序">
              <el-input maxlength="8" v-model.number="formData.orderNum" placeholder="0~100" :disabled="flag == 'look'"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">

            <el-form-item label="发表日期">
              <el-date-picker :disabled="flag == 'look'" v-model="formData.createTime" type="date" placeholder="选择日期" format="yyyy年MM月dd日" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="封面图片">
              <el-upload :disabled="flag == 'look'" class="avatar-uploader" :http-request="uploadfile" action="" :show-file-list="false">
                <img class="avatar" v-if="formData.url" :src="formData.url">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="简介">
              <el-input maxlength="300" v-model="formData.remark" placeholder="请在此输入新闻简介" type="textarea" :rows="2" :disabled="flag == 'look'"></el-input>
            </el-form-item>
          </el-col>

          <el-col v-show="flag == 'look'" :span="24">
            <!-- 查看 -->
            <el-form-item label="详情">
              <div style="max-height: 380px;" v-html="formData.content"></div>
            </el-form-item>
          </el-col>
          <el-col v-show="flag != 'look'" :span="24">
            <!-- 编辑 -->
            <el-form-item label="详情">
              <wangeditor ref="wangeditor" />
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addformData = false">取 消</el-button>
        <el-button type="primary" @click="save">保 存</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import wangeditor from '@/components/wangeditor'
import api from '@/apis/recommend/culture'
import upapi from '@/apis/upload'
export default {
  components: {
    wangeditor,
  },
  data() {
    return {
      addformData: false,
      flag: 'look',
      formData: {},
      tableData: [
        // {
        //   date: '2016-05-02',
        //   name: '王小虎',
        //   address: '上海市普陀区金沙江路 1518 弄',
        // },
      ],
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    getlist() {
      api
        .list({
          params: {
            limit: 100,
            page: 1,
          },
        })
        .then((res) => {
          if (res.code === 10000) {
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        })
    },
    addFrom() {
      this.flag = 'add'
      this.formData = {
        createTime: '',
        title: '',
        orderNum: 0,
        content: '',
        url: '',
      }
      this.addformData = true
      //清空文本编辑器
      this.$nextTick(() => {
        this.$refs.wangeditor.clear()
      })
    },
    edit(row) {
      this.flag = 'edit'
      this.formData = row
      this.addformData = true
      this.$nextTick(() => {
        this.$refs.wangeditor.sethtml(row.content)
      })
    },
    handleClose(done) {
      if (this.flag == 'look') {
        return done()
      }
      this.$confirm('确认关闭？ 数据不会被保存！')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
    save() {
      this.formData.content = this.$refs.wangeditor.gethtml()
      api.save(this.formData).then((res) => {
        if (res.code === 10000) {
          this.$message.success(res.message)
          this.addformData = false
        } else {
          this.$message.error(res.message)
        }
        this.getlist()
      })
    },
    del(item) {
      this.$confirm(`确定删除数据？`).then(() => {
        api.del([item.id]).then((res) => {
          if (res.code === 10000) {
            this.$message.success(res.message)
          } else {
            this.$message.error(res.message)
          }
          this.getlist()
        })
      })
    },
    //上传图片
    uploadfile(val) {
      let fd = new FormData()
      fd.append('file', val.file)
      upapi.upload(fd).then((res) => {
        if (res.code == 10000) {
          this.formData.url = res.data
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
}
</script>

<style lang="less">
.culture { padding-top: 15px;
  .avatar,
  .avatar-uploader-icon {
    width: 9rem !important;
    height: 6rem !important; border:#3570ff solid 1px; border-radius: 4px; font-size: 2rem;
    line-height: 6rem !important;
  }
}
</style>